import config from '../config';
import selectedEnvironment from '../env';
import { formatDate_MM_YYYY } from '../Utils/FormatDate';
import authService from './auth.service';
const API_Clients_URL = `${config[selectedEnvironment].API_URL}/Clients`;
const API_Reports_URL = `${config[selectedEnvironment].API_URL}/Reports`;
const API_ReportedTaxes_URL = `${config[selectedEnvironment].API_URL}/ReportedTaxes`;
const API_CaseRelationship_URL = `${config[selectedEnvironment].API_URL}/CaseRelationship`;

// const API_Clients_URL = 'https://accounting-manager.com:5163/api/Clients';
// const API_ReportedTaxes_URL = 'https://accounting-manager.com:5163/api/ReportedTaxes';

const GetClients = async (accountantId, token, page, pageSize, isActive = true) => {
    try {
        const response = await fetch(`${API_Clients_URL}/GetClientsByAccountantId`, {
            method: 'POST',
            headers: {
                "Authorization": 'Bearer ' + token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ accountantId, page, pageSize, isActive })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
        // return response.body;
    } catch (error) {
    }
};

const GetMinimalClients = async (accountantId, token, page, pageSize, isActive = true) => {
    try {
        const response = await fetch(`${API_Clients_URL}/GetMinimalClientsByAccountantId`, {
            method: 'POST',
            headers: {
                "Authorization": 'Bearer ' + token,
                "Content-Type": "application/json",
            },
            // The server defaults to excluding ManageOnly clients (so older mobile apps work without an
            // update). The website needs to see them, so we explicitly opt in by sending `false`.
            body: JSON.stringify({ accountantId, page, pageSize, isActive, excludeManageOnly: false })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
        // return response.body;
    } catch (error) {
    }
};

// Function to download and handle a report file
const DownloadReport = async (CaseId, date, type, auth) => {
    try {
        // Make the HTTP request to get the file data
        const response = await fetch(`${API_Clients_URL}/Download${type}Report`, {
            method: 'POST',
            headers: {
                "Authorization": 'Bearer ' + auth,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ CaseId, date })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Get the file content from the response
        const fileContent = await response.blob();
        // Create a URL for the file
        const fileUrl = window.URL.createObjectURL(fileContent);

        // Create a temporary link and trigger the download
        const link = document.createElement('a');
        link.href = fileUrl;
        link.setAttribute('download', 'report.xlsx');
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
    } catch (err) {
        alert("Error downloading the report. Please try again.");
    }
};

const DownloadDATReport = async (CaseId, date, type, auth) => {
    try {
        // Make the HTTP request to get the file data
        const response = await fetch(`${API_Clients_URL}/Download${type}Report`, {
            method: 'POST',
            headers: {
                "Authorization": 'Bearer ' + auth,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ CaseId, date })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Get the file content from the response
        const fileContent = await response.blob();

        // Create a URL for the file
        const fileUrl = window.URL.createObjectURL(fileContent);

        // Create a temporary link and trigger the download
        const link = document.createElement('a');
        link.href = fileUrl;
        link.setAttribute('download', 'MOVEIN.DAT'); // Set the correct file name here
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
    } catch (err) {
        console.error("Error downloading the report: ", err);
        alert("Error downloading the report. Please try again.");
    }
};










const UpdateClient = async (token, client) => {
    const response = await fetch(`${API_Clients_URL}/Update`, {
        method: 'PUT',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...client })
    });

    if (!response.ok) {
        let errorBody = null;
        try {
            const text = await response.text();
            if (text) errorBody = JSON.parse(text);
        } catch (_) { /* ignore */ }
        const err = new Error(errorBody?.message || `HTTP error! status: ${response.status}`);
        err.status = response.status;
        err.body = errorBody;
        throw err;
    }

    return response;
};

const BulkSendNotifications = async (token, payload) => {
    const response = await fetch(`${API_Clients_URL}/BulkSendNotifications`, {
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            caseIds: payload.caseIds,
            sendWelcomeEmail: !!payload.sendWelcomeEmail,
            sendWelcomeWhatsApp: !!payload.sendWelcomeWhatsApp,
            sendDocumentsInfoEmail: !!payload.sendDocumentsInfoEmail,
            sendDocumentsInfoWhatsApp: !!payload.sendDocumentsInfoWhatsApp,
            welcomePassword: payload.welcomePassword || null,
        }),
    });

    if (!response.ok) {
        let errorBody = null;
        try {
            const text = await response.text();
            if (text) errorBody = JSON.parse(text);
        } catch (_) { /* ignore */ }
        const err = new Error(errorBody?.message || errorBody || `HTTP error! status: ${response.status}`);
        err.status = response.status;
        err.body = errorBody;
        throw err;
    }

    return response.json();
};

/** Updates only the client Notes field. */
const UpdateClientNotes = async (token, caseId, notes) => {
    const response = await fetch(`${API_Clients_URL}/UpdateNotes`, {
        method: 'PUT',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ caseId, notes }),
    });

    if (!response.ok) {
        let errorBody = null;
        try {
            const text = await response.text();
            if (text) errorBody = JSON.parse(text);
        } catch (_) { /* ignore */ }
        const err = new Error(errorBody?.message || `HTTP error! status: ${response.status}`);
        err.status = response.status;
        err.body = errorBody;
        throw err;
    }

    return response.json();
};

const GetClient = async (token, caseId) => {
    try {
        const response = await fetch(`${API_Clients_URL}/${caseId}`, {
            method: 'GET',
            headers: {
                "Authorization": 'Bearer ' + token,
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
    }
};

const DeleteClient = async (token, caseId) => {
    try {
        const response = await fetch(`${API_Clients_URL}/Delete/${caseId}`, {
            method: 'DELETE',
            headers: {
                "Authorization": 'Bearer ' + token,
                "Content-Type": "application/json",
            },
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return response;
    } catch (error) {
    }
};

const GetClientCounts = async (token, accountantId) => {
    try {
        const response = await fetch(`${API_Clients_URL}/GetSumClientsByAccountantId/${accountantId}`, {
            method: 'GET',
            headers: {
                "Authorization": 'Bearer ' + token,
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
    }
};
const UpdateReportingMonth = async (CaseId, ReportingMonthDate, IsClosed, auth) => {
    const response = await fetch(`${API_Clients_URL}/UpdateReportingMonth`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + auth,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ CaseId, ReportingMonthDate, IsClosed })
    });

    return response;
};

const GetYearMonthsStatus = async (caseId, year, auth) => {
    const response = await fetch(`${API_Clients_URL}/GetYearMonthsStatus/${caseId}/${year}`, {
        method: 'GET',
        headers: {
            "Authorization": 'Bearer ' + auth,
            "Content-Type": "application/json"
        }
    });

    if (!response.ok) {
        throw new Error('Failed to fetch year months status');
    }

    return await response.json();
};

const CheckIfMonthClosed = async (CaseId, ReportingMonthDate, auth) => {
    const response = await fetch(`${API_Clients_URL}/CheckMonthClosed`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + auth,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ CaseId, ReportingMonthDate })
    });

    return response;
};

const GetIncomeTaxAdvances = async (CaseId, date, checkType, auth) => {
    const response = await fetch(`${API_Clients_URL}/GetIncomeTaxAdvances`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + auth,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ CaseId, date, checkType })
    });

    return response;
};

const GetIncomeTaxAdvancesByDateRange = async (CaseId, date, endDate, checkType, auth, useAdvancedReportingType = null) => {
    const body = { CaseId, date, endDate, checkType };
    if (useAdvancedReportingType === true || useAdvancedReportingType === false) {
        body.UseAdvancedReportingType = useAdvancedReportingType;
    }
    const response = await fetch(`${API_Clients_URL}/GetIncomeTaxAdvancesDateRange`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + auth,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
    });

    return response;
};

/** Uploads per upload month and document type, on the XtramBilling ExtraUploads basis. */
const GetClientUploadsBreakdown = async (token, caseId) => {
    const response = await fetch(`${API_Clients_URL}/GetUploadsBreakdown/${encodeURIComponent(caseId)}`, {
        method: 'GET',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json",
        },
    });
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
};

const GetClientUploads = async (token, caseId) => {

    try {
        const response = await fetch(`${API_Clients_URL}/GetTotalUploadsByCaseId/${caseId}`, {
            method: 'GET',
            headers: {
                "Authorization": 'Bearer ' + token,
                "Content-Type": "application/json",
            },
        });


        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
    }

};
const ProfitAndLossDetails = async (caseId, accountantId, date, endDate, token) => {
    try {
        const response = await fetch(`${API_Clients_URL}/ProfitAndLossDetails`, {
            method: 'POST',
            headers: {
                "Authorization": 'Bearer ' + token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ caseId, accountantId, date, endDate })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return response;
    } catch (error) {
    }
};

const ProfitAndLossDetailsYearly = async (caseId, accountantId, date, endDate, token, filterByDocumentDate = true) => {
    try {
        const response = await fetch(`${API_Clients_URL}/ProfitAndLossDetailsByYear`, {
            method: 'POST',
            headers: {
                "Authorization": 'Bearer ' + token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ caseId, accountantId, date, endDate, filterByDocumentDate })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return response;
    } catch (error) {
    }
};


const ProfitAndLossDetailsYearlyReport = async (caseId, accountantId, date, endDate, token,showPct) => {

    const response = await fetch(`${API_Clients_URL}/ProfitAndLossDetailsByYearReport`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ caseId, accountantId, date, endDate,showPct })
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Get the file content from the response
    const fileContent = await response.blob();

    // Create a URL for the file
    const fileUrl = window.URL.createObjectURL(fileContent);

    // Create a temporary link and trigger the download
    const link = document.createElement('a');
    link.href = fileUrl;
    link.setAttribute('download', `${caseId}_${formatDate_MM_YYYY(date)}-${formatDate_MM_YYYY(endDate)}_דווח_רווח_הפסד.pdf`); // Set the correct file name here
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);

};


const ProfitAndLossDetailsMonthlyReport = async (caseId, accountantId, date, endDate, token,showPct) => {
    const response = await fetch(`${API_Clients_URL}/ProfitAndLossDetailsByMonthlyReport`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ caseId, accountantId, date, endDate,showPct })
    });


    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Get the file content from the response
    const fileContent = await response.blob();

    // Create a URL for the file
    const fileUrl = window.URL.createObjectURL(fileContent);

    // Create a temporary link and trigger the download
    const link = document.createElement('a');
    link.href = fileUrl;
    link.setAttribute('download', `${caseId}_${formatDate_MM_YYYY(date)}-${formatDate_MM_YYYY(endDate)}_דווח_רווח_הפסד.pdf`); // Set the correct file name here
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
};



const SortCodeDetails = async (caseId, accountantId, date, endDate, token, sortCodeId, isMonthly = true, segmentationFilter = null, filterByDocumentDate = false) => {
    try {
        const body = { caseId, accountantId, date, endDate, sortCodeId, isMonthly, filterByDocumentDate };
        if (segmentationFilter?.profitAndLossType === 'Projects') {
            body.profitAndLossType = 'Projects';
            if (segmentationFilter.fromSegmentationId) {
                body.fromSegmentationId = segmentationFilter.fromSegmentationId;
            }
            if (segmentationFilter.toSegmentationId) {
                body.toSegmentationId = segmentationFilter.toSegmentationId;
            }
        }
        const response = await fetch(`${API_Clients_URL}/SortCodeDetails`, {
            method: 'POST',
            headers: {
                "Authorization": 'Bearer ' + token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return response;
    } catch (error) {
    }
};

const ReportedTaxesDetails = async (caseId, startDate, endDate, isRange, token) => {
    try {
        const response = await fetch(`${API_ReportedTaxes_URL}/ByDateRange?caseId=${caseId}&startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}&isRange=${isRange}`, {
            method: 'GET',
            headers: {
                "Authorization": 'Bearer ' + token,
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Failed to fetch reported taxes details:', error);
        return null;
    }
};

const UpdateReportedTax = async (reportedTax, token) => {

    const { id, ...taxData } = reportedTax;

    const response = await fetch(`${API_ReportedTaxes_URL}/Update/${reportedTax.id}`, {
        method: 'PUT',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(taxData)
    });

    return response;
};


const CreateReportedTax = async (caseId, reportedTax, startDate, endDate, token) => {
    reportedTax.caseId = caseId;
    reportedTax.startDate = startDate;
    reportedTax.endDate = endDate;

    const response = await fetch(`${API_ReportedTaxes_URL}/Create`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(reportedTax)
    });

    return response;
};




const SortCodeDetailsReport = async (caseId, accountantId, date, endDate, sortCodeId, token, isMonthly = true, segmentationFilter = null, filterByDocumentDate = false) => {
    const body = { caseId, date, endDate, accountantId, sortCodeId, isMonthly, filterByDocumentDate };
    if (segmentationFilter?.profitAndLossType === 'Projects') {
        body.profitAndLossType = 'Projects';
        if (segmentationFilter.fromSegmentationId) {
            body.fromSegmentationId = segmentationFilter.fromSegmentationId;
        }
        if (segmentationFilter.toSegmentationId) {
            body.toSegmentationId = segmentationFilter.toSegmentationId;
        }
    }

    const response = await fetch(`${API_Clients_URL}/SortCodeDetailsReport`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body)
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Get the file content from the response
    const fileContent = await response.blob();

    // Create a URL for the file
    const fileUrl = window.URL.createObjectURL(fileContent);

    // Create a temporary link and trigger the download
    const link = document.createElement('a');
    link.href = fileUrl;
    link.setAttribute('download', 'SortCodeREPORT.pdf'); // Set the correct file name here
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);

};

const DownloadJournalEntryReport = async (CaseId, date, endDate, type, auth) => {
    try {
        // Make the HTTP request to get the file data
        const response = await fetch(`${API_Clients_URL}/DownloadJournalEntryReport`, {
            method: 'POST',
            headers: {
                "Authorization": 'Bearer ' + auth,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ CaseId, date, endDate, type })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Extract the Content-Disposition header
        const contentDisposition = response.headers.get('Content-Disposition');
        // Get the file content from the response
        const fileContent = await response.blob();
        // Create a URL for the file
        const fileUrl = window.URL.createObjectURL(fileContent);
        const link = document.createElement('a');
        // Create a temporary link and trigger the download
        link.href = fileUrl;
        // Regular expression to extract the filename
        // const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        // const matches = filenameRegex.exec(contentDisposition);
        // let filename = 'report.xlsx'; // Default filename

        // if (matches != null && matches[1]) {
        //     filename = matches[1].replace(/['"]/g, ''); // Remove quotes
        // }

        // // Get the file content from the response
        // const fileContent = await response.blob();

        // // Create a URL for the file
        // const fileUrl = window.URL.createObjectURL(fileContent);

        // // Create a temporary link and trigger the download
        // const link = document.createElement('a');
        // link.href = fileUrl;
        // link.setAttribute('download', 'פקודת יומן.txt');
        // document.body.appendChild(link);
        // link.click();
        // link.parentNode.removeChild(link);

        link.setAttribute('download', 'report.txt');
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
    } catch (err) {
        console.error(err);
        alert("Error downloading the report. Please try again.");
    }
};

const DownloadJournalEntryDatReport = async (CaseId, date, endDate, type, auth) => {
    try {

        // Make the HTTP request to get the file data
        const response = await fetch(`${API_Clients_URL}/DownloadJournalEntryDatReport`, {
            method: 'POST',
            headers: {
                "Authorization": 'Bearer ' + auth,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ CaseId, date, endDate, type })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        // Extract the Content-Disposition header
        const contentDisposition = response.headers.get('Content-Disposition');

        // Regular expression to extract the filename
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(contentDisposition);
        let filename = 'report.xlsx'; // Default filename

        if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, ''); // Remove quotes
        }

        // Get the file content from the response
        const fileContent = await response.blob();

        // Create a URL for the file
        const fileUrl = window.URL.createObjectURL(fileContent);

        // Create a temporary link and trigger the download
        const link = document.createElement('a');
        link.href = fileUrl;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
    } catch (err) {
        console.error(err);
        alert("Error downloading the report. Please try again.");
    }
};

const DownloadAccountantCardReport = async (CaseId, date, type, auth) => {
    try {
        // Make the HTTP request to get the file data
        const response = await fetch(`${API_Clients_URL}/DownloadAccountantCardReport`, {
            method: 'POST',
            headers: {
                "Authorization": 'Bearer ' + auth,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ CaseId, date })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const fileContent = await response.blob();

        const fileUrl = window.URL.createObjectURL(fileContent);

        const link = document.createElement('a');
        link.href = fileUrl;
        link.setAttribute('download', 'כרטיסי חשבון.txt');
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
    } catch (err) {
        console.error(err);
        alert("Error downloading the report. Please try again.");
    }
};


const DownloadAccountantCardReportDat = async (CaseId, date, type, auth) => {
    try {
        // Make the HTTP request to get the file data
        const response = await fetch(`${API_Clients_URL}/DownloadAccountantCardReportDat`, {
            method: 'POST',
            headers: {
                "Authorization": 'Bearer ' + auth,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ CaseId, date })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        // Extract the Content-Disposition header
        const contentDisposition = response.headers.get('Content-Disposition');

        // Regular expression to extract the filename
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(contentDisposition);
        let filename = 'report.xlsx'; // Default filename

        if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, ''); // Remove quotes
        }

        // Get the file content from the response
        const fileContent = await response.blob();

        // Create a URL for the file
        const fileUrl = window.URL.createObjectURL(fileContent);

        // Create a temporary link and trigger the download
        const link = document.createElement('a');
        link.href = fileUrl;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
    } catch (err) {
        console.error(err);
        alert("Error downloading the report. Please try again.");
    }
};

const VATReport = async (caseId, accountantId, Date, EndDate, token, onlyProcessed = true) => {

    const response = await fetch(`${API_Clients_URL}/VATReport`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ CaseId: caseId, AccountantId: accountantId, Date, EndDate, OnlyProcessed: !!onlyProcessed })
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Get the file content from the response
    const fileContent = await response.blob();

    // Create a URL for the file
    const fileUrl = window.URL.createObjectURL(fileContent);

    // Create a temporary link and trigger the download
    const link = document.createElement('a');
    link.href = fileUrl;
    link.setAttribute('download', 'VATReport.pdf'); // Set the correct file name here
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);

};




const WithholdingTaxReportTracking = async (accountantId, StartDate, EndDate, isRange, token) => {

    const response = await fetch(`${API_ReportedTaxes_URL}/DetailsByDateRange`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ accountantId, StartDate, EndDate, isRange })
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response;

};

const sendVatReport = async (reportedTax, token) => {

    const response = await fetch(`${API_ReportedTaxes_URL}/SendVatReporting`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(reportedTax)
    });

    return response;
};

const sendAdvancesReport = async (reportedTax, token) => {

    const response = await fetch(`${API_ReportedTaxes_URL}/SendAdvancesReport`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(reportedTax)
    });

    return response;
};

const GetClientsBySubAccountantId = async (accountantId, subAccountantId, token, page, pageSize, isActive = true) => {
    // Build query parameters
    const response = await fetch(`${API_Clients_URL}/GetClientsBySubAccountantId`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ accountantId, subAccountantId, page, pageSize, isActive })
    });
    const data = await response.json();
    return data;
};

const GetMinimalClientsBySubAccountantId = async (accountantId, subAccountantId, token, page, pageSize, isActive = true) => {
    // Build query parameters
    const response = await fetch(`${API_Clients_URL}/GetMinimalClientsBySubAccountantId`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ accountantId, subAccountantId, page, pageSize, isActive })
    });
    const data = await response.json();
    return data;
};


const CreateConstantInvoiceDetails = async (dto, token) => {
    try {
        const response = await fetch(`${API_Clients_URL}/CreateConstantInvoiceDetails`, {
            method: 'POST',
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(dto)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error creating Constant Invoice Details:', error);
        throw error;
    }
};

const GetConstantInvoiceDetailsByCaseId = async (caseId, token) => {
    try {

        const response = await fetch(`${API_Clients_URL}/GetConstantInvoiceDetailsByCaseId?CaseId=${caseId}`, { // Ensure 'CaseId' matches the backend DTO
            method: 'GET',
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });

        return response;
    } catch (error) {
        console.error('Error getting Constant Invoice Details by CaseId:', error);
        throw error;
    }
};


// 1) UploadProfilePhoto
const UploadProfilePhoto = async (token, accountantId, caseId, photoFile) => {
    // Prepare a FormData object
    const formData = new FormData();
    formData.append('AccountantId', accountantId);
    formData.append('CaseId', caseId);
    formData.append('Photo', photoFile); // The actual file

    try {
        const response = await fetch(`${API_Clients_URL}/UploadProfilePhoto`, {
            method: 'PUT',
            headers: {
                "Authorization": `Bearer ${token}`
                // Note: Do NOT set "Content-Type" here; 
                // fetch will automatically set the correct boundary for FormData
            },
            body: formData
        });

        // The server returns JSON with { message, url }
        return response;
    } catch (error) {
        console.error("Error uploading profile photo:", error);
        throw error;
    }
};

// 2) UploadSignature
const UploadSignature = async (token, accountantId, caseId, signatureFile) => {
    // Prepare a FormData object
    const formData = new FormData();
    formData.append('AccountantId', accountantId);
    formData.append('CaseId', caseId);
    formData.append('Photo', signatureFile); // The actual file

    try {
        const response = await fetch(`${API_Clients_URL}/UploadSignature`, {
            method: 'PUT',
            headers: {
                "Authorization": `Bearer ${token}`
            },
            body: formData
        });

        // The server returns JSON with { message, url }
        return response;
    } catch (error) {
        console.error("Error uploading signature:", error);
        throw error;
    }
};

// UploadPageBackground - full-page document watermark / letterhead image
const UploadPageBackground = async (token, accountantId, caseId, photoFile) => {
    const formData = new FormData();
    formData.append('AccountantId', accountantId);
    formData.append('CaseId', caseId);
    formData.append('Photo', photoFile);

    try {
        const response = await fetch(`${API_Clients_URL}/UploadPageBackground`, {
            method: 'PUT',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: formData,
        });
        return response;
    } catch (error) {
        console.error('Error uploading page background:', error);
        throw error;
    }
};

// ClearSignature - clears/removes the signature
const ClearSignature = async (token, caseId) => {
    try {
        const response = await fetch(`${API_Clients_URL}/ClearSignature`, {
            method: 'PUT',
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ CaseId: caseId })
        });

        return response;
    } catch (error) {
        console.error("Error clearing signature:", error);
        throw error;
    }
};

// ClearProfilePhoto - clears/removes the profile picture
const ClearProfilePhoto = async (token, caseId) => {
    try {
        const response = await fetch(`${API_Clients_URL}/ClearProfilePhoto`, {
            method: 'PUT',
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ CaseId: caseId })
        });

        return response;
    } catch (error) {
        console.error("Error clearing profile photo:", error);
        throw error;
    }
};

// 3) Get pre-signed URL for existing signature
const GetSignaturePresignedUrl = async (token, caseId, asBase64 = true) => {
    try {
        // Request signature as base64 to avoid CORS issues
        const url = asBase64 
            ? `${API_Clients_URL}/GetSignatureUrl/${caseId}?asBase64=true`
            : `${API_Clients_URL}/GetSignatureUrl/${caseId}`;
            
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return response;
    } catch (error) {
        console.error("Error getting signature URL:", error);
        throw error;
    }
};

// 4) Get pre-signed URL for existing profile photo
const GetProfilePhotoPresignedUrl = async (token, caseId) => {
    try {
        const response = await fetch(`${API_Clients_URL}/GetProfilePhotoUrl/${caseId}`, {
            method: 'GET',
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return response;
    } catch (error) {
        console.error("Error getting profile photo URL:", error);
        throw error;
    }
};

// In your ClientService file:

const DownloadUniformFile = async (dto, token) => {
    const response = await fetch(`${config[selectedEnvironment].API_URL}/Bmkvd/DownloadUniformFile`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(dto)
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Get the file content as a blob
    const blob = await response.blob();

    // Force a file download in the browser
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `UniformFile_${dto.caseId}.zip`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};


/* ────────────────────────────────────────────────────────────── */
/* Leading-Business helpers                                       */
/* ────────────────────────────────────────────────────────────── */

/** 1️⃣  Check if any *other* client of the accountant is already a leading business */
const CheckIfLeadingBusinessExists = async (token, accountantId) => {
    const res = await fetch(
        `${API_Clients_URL}/CheckIfLeadingBusinessExists/${accountantId}`,
        {
            method: "GET",
            headers: {
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json",
            },
        }
    );

    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
    return res.json();   // { success: true, leadingBusinessExists: boolean }
};

/** 2️⃣  Mark this client as the accountant’s single leading business */
const SetLeadingBusiness = async (token, accountantId, caseId) => {
    const res = await fetch(`${API_Clients_URL}/SetLeadingBusiness`, {
        method: "PUT",
        headers: {
            "Authorization": "Bearer " + token,
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ accountantId, caseId }),
    });

    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
    return res.json();   // { message: "... set as leading business." }
};

const UpdateWithholdingReporting = async (token, caseId, year, month, value) => {
    const res = await fetch(`${API_Clients_URL}/UpdateWithholdingReporting`, {
        method: 'PUT',
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ caseId, year, month, value }),
    });
    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
    return res.json();
};

const GetWithholdingReportingForAccountantForMonth = async (accountantId, year, month, token) => {
    const res = await fetch(`${API_Clients_URL}/GetWithholdingReportingForAccountantForMonth`, {
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ accountantId, year, month }),
    });
    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
    return res.json();
};

/** 3️⃣  Remove the leading-business flag from this client */
const RemoveLeadingBusiness = async (token, accountantId, caseId) => {
    const res = await fetch(`${API_Clients_URL}/RemoveLeadingBusiness`, {
        method: "PUT",
        headers: {
            "Authorization": "Bearer " + token,
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ accountantId, caseId }),
    });

    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
    return res.json();   // { message: "... is no longer a leading business." }
};


const GetAllClientNames = async (accountantId, token) => {
    const res = await fetch(
        `${API_Clients_URL}/MinimalList/${accountantId}`,
        {
            method: "GET",
            headers: {
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json",
            },
        }
    );

    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
    return res.json();               // → [ {caseId:"...", name:"..."}, … ]
};
const VerifyLoginOffice = async (caseId, officePassword, token) => {

    const res = await fetch(`${API_Clients_URL}/VerifyLoginOffice`, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ caseId, officePassword }),
    });

    // 200 OK = valid, 401 = wrong pwd, 404 = no client
    return res;              // caller can inspect res.ok / res.status
};

// Case Relationship methods
const CreateCaseRelationship = async (token, caseRelationshipData) => {
    const res = await fetch(`${API_CaseRelationship_URL}/CreateCaseRelationship`, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(caseRelationshipData)
    });
    return res;
};

const UpdateCaseRelationship = async (token, caseRelationshipData) => {
    const res = await fetch(`${API_CaseRelationship_URL}/UpdateCaseRelationship`, {
        method: 'PUT',
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(caseRelationshipData)
    });
    return res;
};

const DeleteCaseRelationship = async (token, relationshipId) => {
    const res = await fetch(`${API_CaseRelationship_URL}/DeleteCaseRelationship/${relationshipId}`, {
        method: 'DELETE',
        headers: {
            Authorization: `Bearer ${token}`,
        }
    });
    return res;
};

const GetCaseRelationshipsByCaseId = async (token, caseId) => {
    const res = await fetch(`${API_CaseRelationship_URL}/GetCaseRelationshipsByCaseId/${caseId}`, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        }
    });
    if (res.ok) {
        return await res.json();
    }
    return null;
};

// Reset a client's login password (Accountant only)
const ResetClientPassword = async (token, caseId, newPassword) => {
    const res = await fetch(`${API_Clients_URL}/ResetPassword`, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ caseId, newPassword }),
    });
    return res;
};

/**
 * Regenerates the CaseId-derived initial password for an accountant.
 * Backend returns 403 once HasChangedInitialPassword is true.
 */
const GetInitialPassword = async (token, caseId) => {
    const res = await fetch(`${API_Clients_URL}/${encodeURIComponent(caseId)}/InitialPassword`, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });
    return res;
};
const setOfficePassword = async (token, caseId, officePassword) => {
    return fetch(`${API_Clients_URL}/SetOfficePassword`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            caseId,           // must match SetOfficePasswordDto
            officePassword,   // property name exactly as in DTO
        }),
    });
};
const resetOfficePassword = async (
    token,
    caseId,
    newOfficePassword
) => {
    return fetch(`${API_Clients_URL}/ResetOfficePassword`, {
        method: "POST",        // controller uses [HttpPost] as well
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            caseId,              // must match ResetOfficePasswordDto
            newOfficePassword,   // property name exactly as in DTO
        }),
    });
};

const VatTransactionDocumentsExist = async (payload, token) => {
  // payload must contain: caseId, accountantId, startDate, endDate
  const res = await fetch(`${API_Reports_URL}/VatTransactionDocumentsExist`, {
    method: 'POST',
    headers: {
      Authorization : `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    // let the caller's try/catch see the problem
    const text = await res.text();               // optional: peek at server msg
    throw new Error(`HTTP ${res.status}: ${text}`);
  }

  return res.json();   // ⬅️ parsed response body
};

/** Get the caseId of the leading business client for a given accountant */
const GetLeadingBusinessCaseId = async (accountantId, token) => {
    const res = await fetch(
        `${API_Clients_URL}/GetLeadingBusinessCaseId/${accountantId}`,
        {
            method: "GET",
            headers: {
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json",
            },
        }
    );

    return res;   // { success: true, data: { caseId, name } }
};

const UpdatePaymentMethod = async (caseId, clientPaymentMethod, token) => {
    try {
        const response = await fetch(`${API_Clients_URL}/UpdatePaymentMethod`, {
            method: 'PUT',
            headers: {
                "Authorization": 'Bearer ' + token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ 
                CaseId: caseId,
                ClientPaymentMethod: clientPaymentMethod // 0 = Accountant, 1 = Client
            })
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error updating payment method:', error);
        throw error;
    }
};

const UpdatePaymentMethodForMonths = async (caseId, months, clientPaymentMethod, token) => {
    try {
        const response = await fetch(`${API_Clients_URL}/UpdatePaymentMethodForMonths`, {
            method: 'POST',
            headers: {
                "Authorization": 'Bearer ' + token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ 
                CaseId: caseId,
                Months: months, // Array of {year, month}
                ClientPaymentMethod: clientPaymentMethod // 0 = Accountant, 1 = Client
            })
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error updating payment method for months:', error);
        throw error;
    }
};

const ClientService = {
    GetClients,
    DownloadReport,
    UpdateClient,
    BulkSendNotifications,
    UpdateClientNotes,
    GetClient,
    DeleteClient,
    DownloadDATReport,
    GetClientCounts,
    UpdateReportingMonth,
    GetYearMonthsStatus,
    CheckIfMonthClosed,
    GetIncomeTaxAdvances,
    GetClientUploads,
    GetClientUploadsBreakdown,
    ProfitAndLossDetails,
    ProfitAndLossDetailsYearly,
    ProfitAndLossDetailsYearlyReport,
    ProfitAndLossDetailsMonthlyReport,
    GetIncomeTaxAdvancesByDateRange,
    SortCodeDetails,
    SortCodeDetailsReport,
    DownloadJournalEntryReport,
    DownloadJournalEntryDatReport,
    DownloadAccountantCardReport,
    DownloadAccountantCardReportDat,
    ReportedTaxesDetails,
    UpdateReportedTax,
    CreateReportedTax,
    VATReport,
    VatTransactionDocumentsExist,

    WithholdingTaxReportTracking,
    sendVatReport,
    sendAdvancesReport,
    GetClientsBySubAccountantId,
    GetMinimalClients,
    GetMinimalClientsBySubAccountantId,
    CreateConstantInvoiceDetails,
    GetConstantInvoiceDetailsByCaseId,
    UploadProfilePhoto,
    UploadSignature,
    UploadPageBackground,
    ClearSignature,
    ClearProfilePhoto,
    GetSignaturePresignedUrl,
    GetProfilePhotoPresignedUrl,
    DownloadUniformFile,
    CheckIfLeadingBusinessExists,
    SetLeadingBusiness,
    UpdateWithholdingReporting,
    GetWithholdingReportingForAccountantForMonth,
    UpdatePaymentMethod,
    UpdatePaymentMethodForMonths,
    RemoveLeadingBusiness,
    GetAllClientNames,
    GetLeadingBusinessCaseId,
    VerifyLoginOffice,
    setOfficePassword,
    resetOfficePassword,
    ResetClientPassword,
    GetInitialPassword,
    
    // Case Relationship methods
    CreateCaseRelationship,
    UpdateCaseRelationship,
    DeleteCaseRelationship,
    GetCaseRelationshipsByCaseId,
};

export default ClientService;